import React from 'react';

interface IBlockedIconProps {
	size?: string;
	className?: string;
}

export const Blocked = ({ size = '24', className }: IBlockedIconProps) => {
	return (
		<svg width={size} height={size} viewBox="0 0 24 25" fill="none" className={`${className}`}>
			<path
				d="M3.10217 18.6111L11.27 4.21732C11.3417 4.09098 11.4473 3.98557 11.5757 3.91215C11.7042 3.83873 11.8507 3.79999 12 3.79999C12.1493 3.79999 12.2958 3.83873 12.4243 3.91215C12.5527 3.98557 12.6583 4.09098 12.73 4.21732L20.8978 18.6111C20.9672 18.7334 21.0024 18.871 20.9999 19.0104C20.9974 19.1499 20.9574 19.2862 20.8837 19.4062C20.8101 19.5261 20.7053 19.6255 20.5798 19.6946C20.4543 19.7636 20.3123 19.8 20.1678 19.8H3.83221C3.68772 19.8 3.54574 19.7636 3.42021 19.6946C3.29469 19.6255 3.18995 19.5261 3.11629 19.4062C3.04263 19.2862 3.0026 19.1499 3.00012 19.0104C2.99765 18.871 3.03281 18.7334 3.10217 18.6111Z"
				stroke="#3D3D3D"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M12 9.79999V13.3" stroke="#3D3D3D" strokeLinecap="square" strokeLinejoin="round" />
			<path
				d="M12 15.55C12.0663 15.55 12.1299 15.5763 12.1768 15.6232C12.2237 15.6701 12.25 15.7337 12.25 15.8"
				fill="#3D3D3D"
			/>
			<path
				d="M12 15.55C12.0663 15.55 12.1299 15.5763 12.1768 15.6232C12.2237 15.6701 12.25 15.7337 12.25 15.8"
				stroke="#3D3D3D"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.75 15.8C11.75 15.7337 11.7763 15.6701 11.8232 15.6232C11.8701 15.5763 11.9337 15.55 12 15.55"
				stroke="#3D3D3D"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 16.05C11.9337 16.05 11.8701 16.0236 11.8232 15.9768C11.7763 15.9299 11.75 15.8663 11.75 15.8"
				stroke="#3D3D3D"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.25 15.8C12.25 15.8663 12.2237 15.9299 12.1768 15.9768C12.1299 16.0236 12.0663 16.05 12 16.05"
				stroke="#3D3D3D"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
